import { render } from "./TheTradeLimitList.vue?vue&type=template&id=1279247b&scoped=true&ts=true"
import script from "./TheTradeLimitList.vue?vue&type=script&lang=ts"
export * from "./TheTradeLimitList.vue?vue&type=script&lang=ts"

import "./TheTradeLimitList.vue?vue&type=style&index=0&id=1279247b&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1279247b"]])

export default __exports__